export const allowedPhonePrefixes = [
  "601",
  "602",
  "603",
  "604",
  "605",
  "606",
  "607",
  "608",
  "702",
  "703",
  "704",
  "705",
  "706",
  "719",
  "720",
  "721",
  "722",
  "723",
  "724",
  "725",
  "726",
  "727",
  "728",
  "729",
  "730",
  "731",
  "732",
  "733",
  "734",
  "735",
  "736",
  "737",
  "738",
  "739",
  "770",
  "771",
  "772",
  "773",
  "774",
  "775",
  "776",
  "777",
  "778",
  "779",
  "790",
  "791",
  "792",
  "793",
  "794",
  "795",
  "797",
  "798",
  "799",
];
